import NotifyPopup from "./component";
export const NOTIFY_POPUP_TYPES = {
  WARNING: "WARNING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  INFO: "INFO",
  ALERT: "ALERT",
};
export interface NotifyPopupConfigParams {
  title?: string;
  closeButtonText?: string;
  notifyOkButtonHandler?: any;
  isPopupShowCloseButton?: boolean;
  notifyPopupType?: string;
  width?: number;
  height?: any;
  visible: boolean;
  isHideNotifyTypeIcon?: boolean;
}
export default NotifyPopup;
